import { AnimatePresence, m } from 'framer-motion';
import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';
import { IconButton } from '@cbhq/cds-web/buttons/IconButton';
import { Grid } from '@cbhq/cds-web/layout';
import { ThemeProvider } from '@cbhq/cds-web/system';
import { spacing } from '@cbhq/cds-web/tokens';
import { jsx, jsxs } from 'react/jsx-runtime';
const i18nKey = 'HighlightTable.scrollIndicator';
const messages = defineMessages({
  scrollToStart: {
    id: `${i18nKey}.scrollToStart`,
    defaultMessage: 'Scroll to start',
    description: `#Component: Title
    #CharLimit: 60
    #Context: Scroll to start button accessibility label.`
  },
  scrollToEnd: {
    id: `${i18nKey}.scrollToEnd`,
    defaultMessage: 'Scroll to end',
    description: `#Component: Title
    #CharLimit: 60
    #Context: Scroll to end button accessibility label.`
  }
});
function HighlightTableScrollIndicator({
  spacingTop,
  style,
  isLeftIndicatorVisible,
  isRightIndicatorVisible,
  onButtonClick
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const darkThemeStyles = ['dark', 'darkwash'];
  const variant = darkThemeStyles.includes(style) ? 'secondary' : 'foregroundMuted';
  const spectrum = darkThemeStyles.includes(style) ? 'dark' : 'light';
  return /*#__PURE__*/jsx(ThemeProvider, {
    spectrum: spectrum,
    children: /*#__PURE__*/jsxs(ScrollIndicatorWrapper, {
      $spacingTop: spacingTop,
      "data-qa": "scrollIndicatorWrapper",
      alignItems: "center",
      templateColumns: "max-content 1fr max-content",
      overflow: "hidden",
      children: [/*#__PURE__*/jsx(AnimatePresence, {
        children: isLeftIndicatorVisible && /*#__PURE__*/jsx(IconWrapper, {
          $gridColumn: 1,
          "data-qa": "scrollIndicatorLeft",
          children: /*#__PURE__*/jsx(IconButton, {
            accessibilityLabel: formatMessage(messages.scrollToStart),
            name: "caretLeft"
            // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
            ,

            onPress: () => onButtonClick('left'),
            variant: variant
          })
        })
      }), /*#__PURE__*/jsx(AnimatePresence, {
        children: isRightIndicatorVisible && /*#__PURE__*/jsx(IconWrapper, {
          $gridColumn: 3,
          "data-qa": "scrollIndicatorRight",
          children: /*#__PURE__*/jsx(IconButton, {
            accessibilityLabel: formatMessage(messages.scrollToEnd),
            name: "caretRight"
            // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
            ,

            onPress: () => onButtonClick('right'),
            variant: variant
          })
        })
      })]
    })
  });
}
const ScrollIndicatorWrapper = styled(Grid)`
  position: absolute;
  top: ${({
  $spacingTop
}) => spacing[$spacingTop]};
  left: ${spacing[1]};
  right: ${spacing[1]};
  bottom: 0;
  pointer-events: none;
`;
const IconWrapper = styled(m.span).attrs(p => ({
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  },
  style: {
    gridColumn: p.$gridColumn
  }
}))`
  pointer-events: all;
`;
export { HighlightTableScrollIndicator };
//# sourceMappingURL=HighlightTableScrollIndicator.js.map
